import { Component, Input } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { MenuService } from './../../../services/menu.service';

@Component({
  selector: 'root-header-nav-item',
  templateUrl: './header-nav-item.component.html',
  styleUrls: ['./header-nav-item.component.scss'],
})
export class HeaderNavComponent {
  @Input() public title = '';
  @Input() public showTitle = true;
  @Input() public icon = '';
  @Input() public skipLocationChange: boolean;
  @Input() public route: string;
  @Input() public outlet: string;
  @Input() public badgeText: string;

  top: number;
  left: number;
  timedOutCloser;

  hasBadge: boolean = false;

  constructor(
    private menuService: MenuService,
    private router: Router
  ) {
    this.hasBadge = this.badgeText && this.badgeText.trim().length > 0;
  }

  showIcon() {
    return this.icon?.length > 0;
  }
  showText() {
    return this.showTitle;
  }

  mouseEnter(trigger) {
    this.menuService.setSubNavPosition(trigger.srcElement);
    this.menuService.onHoverEnter(trigger.srcElement.title);
  }

  mouseLeave(trigger) {
    this.menuService.setSubNavPosition(trigger.srcElement);
    this.menuService.onHoverLeave();
  }

  async reRouteToOutlet(event): Promise<void> {
    this.menuService.setSubNavPosition(event.srcElement);
    this.menuService.stickMenuItem(this.title);
    if (this.route) {
      (event as Event).preventDefault();
      const calculatedRoute = [];

      if (this.outlet?.length > 0) {
        const outletPath = this.router.url === '/' ? { primary: this.router.url } : {};
        outletPath[this.outlet] = [this.route];
        calculatedRoute.push({ outlets: outletPath });

        await this.router.navigate(calculatedRoute, { skipLocationChange: this.skipLocationChange });
      } else {
        this.navigateWithoutChangingUrl(this.route);
      }
    }
  }

  navigateWithoutChangingUrl(route: string) {
    const primaryRoute = route; // your primary route
    const clearOutlet = [{ outlets: { profilePopup: null } }]; // your outlet clearing
    const navigationExtras: NavigationExtras = { skipLocationChange: true };

    this.router.navigate([primaryRoute], navigationExtras).then(() => {
      this.router.navigate(clearOutlet);
    });
  }

  isActiveMenuItem(): boolean {
    if (!this.showIcon()) {
      return this.title === this.menuService.currentMenuItem();
    }
    return false;
  }
}
